/* PetsPortrait theme: homepage + shared section behaviour (reviews, deck, styles, counter, before/after, gift, compare, final). */
(function () {
  'use strict';
  const start = () => {
    const PP = window.PP; if (!PP || !PP.register) return setTimeout(start, 30);
    const { RM, $, $$, buzz } = PP;
    const once = (el, key) => { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true };

    /* ===== reviews: data registry, summary, filters, lightbox, strip ===== */
    const REV = PP.reviewData = PP.reviewData || { items: [], tags: {} };
    function loadRevData() {
      const el = $('[data-rev-data]'); if (!el) return;
      try { const d = JSON.parse(el.textContent); REV.items = d.items || []; REV.tags = d.tags || {} } catch (e) { console.error(e) }
    }
    const LB = (function () {
      const lb = $('#rlb'); if (!lb) return { open() {} };
      const panel = $('.rlb-panel', lb), img = $('[data-rlb-img]', lb), bg = $('.bgblur', lb), body = $('.rlb-body', lb);
      let list = [], pos = 0, lastFocus;
      const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      function fill(i, dir) {
        const r = REV.items[list[i]]; if (!r) return; pos = i;
        const go = () => {
          if (r.img) { img.src = r.img; bg.style.backgroundImage = `url("${r.img}")` }
          img.alt = r.alt || ''; img.removeAttribute('width'); img.removeAttribute('height');
          $('[data-rlb-q]', lb).textContent = '“' + r.q + '”';
          $('[data-rlb-t]', lb).innerHTML = esc(r.t).replace(/\[\[/g, '<mark>').replace(/\]\]/g, '</mark>');
          $('[data-rlb-name]', lb).textContent = r.n;
          $('[data-rlb-meta]', lb).textContent = [r.s, r.d].filter(Boolean).join(' · ');
          $('[data-rlb-tags]', lb).innerHTML = (r.g || []).filter(t => REV.tags[t]).map(t => `<span>${esc(REV.tags[t])}</span>`).join('');
          $('[data-rlb-tr]', lb).textContent = r.en ? (PP.t.reviewOriginal || '') : (PP.t.reviewTranslated || '');
          $('[data-rlb-count]', lb).textContent = (i + 1) + ' / ' + list.length;
          img.classList.remove('swap'); body.classList.remove('swap'); body.scrollTop = 0;
        };
        if (dir && !RM) { img.style.setProperty('--dir', dir); img.classList.add('swap'); body.classList.add('swap'); setTimeout(go, 180) } else go();
        [i - 1, i + 1].forEach(k => { const x = REV.items[list[(k + list.length) % list.length]]; if (x && x.img) { const p = new Image(); p.src = x.img } });
      }
      function open(idx, from) {
        if (!REV.items.length) loadRevData();
        if (!REV.items[idx]) return;
        list = from && from.includes(idx) ? from : REV.items.map((_, k) => k);
        lastFocus = document.activeElement;
        fill(list.indexOf(idx)); lb.hidden = false; void lb.offsetWidth;
        lb.classList.add('on'); document.body.classList.add('locked');
        setTimeout(() => $('.rlb-x', lb).focus({ preventScroll: true }), 60);
      }
      function close() {
        lb.classList.remove('on'); document.body.classList.remove('locked'); panel.style.transform = '';
        setTimeout(() => { if (!lb.classList.contains('on')) lb.hidden = true }, RM ? 0 : 520);
        lastFocus && lastFocus.focus({ preventScroll: true });
      }
      const step = d => { fill((pos + d + list.length) % list.length, d); buzz() };
      $('.rlb-x', lb).addEventListener('click', close);
      $('.rlb-scrim', lb).addEventListener('click', close);
      $('[data-rlb-prev]', lb).addEventListener('click', () => step(-1));
      $('[data-rlb-next]', lb).addEventListener('click', () => step(1));
      lb.addEventListener('keydown', e => {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') step(1);
        else if (e.key === 'ArrowLeft') step(-1);
        else if (e.key === 'Tab') { const f = $$('button:not([hidden])', lb).filter(x => x.offsetParent); const a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus() } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus() } }
      });
      const media = $('.rlb-media', lb); let sx = null, sy = 0;
      media.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY });
      media.addEventListener('pointerup', e => { if (sx === null) return; const dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1) });
      const grab = $('.grab', lb); let y0 = null, dy = 0;
      grab.addEventListener('pointerdown', e => { y0 = e.clientY; dy = 0; panel.classList.add('drag'); grab.setPointerCapture(e.pointerId) });
      grab.addEventListener('pointermove', e => { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = `translateY(${dy}px)` });
      const up = () => { if (y0 === null) return; y0 = null; panel.classList.remove('drag'); if (dy > 90 || dy < 4) close(); else panel.style.transform = '' };
      grab.addEventListener('pointerup', up); grab.addEventListener('pointercancel', up);
      return { open };
    })();
    PP.openReview = LB.open;

    function initReviews(root) {
      loadRevData();
      $$('[data-section-type="reviews"]', root).forEach(sec => {
        if (!once(sec, 'ppRev')) return;
        const sum = $('[data-rsum]', sec), acc = $('[data-dist-acc]', sec);
        if (sum) {
          if (acc) {
            const deskQ = matchMedia('(min-width:980px)'); const syncAcc = () => { if (deskQ.matches) acc.open = true }; syncAcc(); deskQ.addEventListener('change', syncAcc);
            acc.addEventListener('toggle', () => { if (acc.open && !RM && sum.classList.contains('go')) { sum.classList.remove('go'); void sum.offsetWidth; requestAnimationFrame(() => sum.classList.add('go')) } });
          }
          PP.onView(sum, () => {
            sum.classList.add('go');
            const n = $('[data-rs-num]', sum), to = parseFloat(String(n.dataset.to).replace(',', '.'));
            if (!isNaN(to)) { const comma = /,/.test(n.dataset.to); PP.countUp(n, to, { dur: 1500, dec: 1, sep: false }); if (comma) setTimeout(() => n.textContent = n.dataset.to, RM ? 0 : 1550) }
            $$('.dist .c', sum).forEach((c, i) => setTimeout(() => PP.countUp(c, +c.dataset.to, { dur: 1300 }), i * 90));
          });
        }
        const track = $('[data-rev-track]', sec), cards = $$('.rc', track);
        PP.carousel(track, $('[data-prog]', sec), $('[data-arrows]', sec));
        let busy;
        const apply = (f, instant) => {
          clearTimeout(busy);
          if (!instant) cards.forEach(c => !c.hidden && c.classList.add('out'));
          busy = setTimeout(() => {
            let n = 0;
            cards.forEach(c => {
              const show = f === 'all' || c.dataset.tags.split(' ').includes(f);
              c.hidden = !show;
              if (show) { c.classList.add('out'); const k = n++; setTimeout(() => c.classList.remove('out'), RM || instant ? 0 : 40 + k * 55) }
            });
            track.scrollTo({ left: 0, behavior: 'auto' }); track._upd && track._upd();
          }, RM || instant ? 0 : 260);
        };
        const chips = $('[data-chips="reviews"]', sec);
        PP.chipGroup(chips, (f, c, silent) => apply(f, silent));
        const def = sec.dataset.defaultFilter;
        if (chips && def && def !== 'all') { const c = $(`.chip[data-f="${def}"]`, chips); c && chips._pick(c, true) }
        $$('.rc-btn', track).forEach(b => b.addEventListener('click', () => {
          const vis = cards.filter(c => !c.hidden).map(c => +c.dataset.i);
          LB.open(+b.closest('.rc').dataset.i, vis);
        }));
      });
      $$('[data-rev]', root).forEach(b => { if (!once(b, 'ppRevBtn')) return; b.addEventListener('click', () => LB.open(+b.dataset.rev, $$('[data-rev]').map(x => +x.dataset.rev))) });
      /* compact strip on the product page, built from the reviews section data */
      $$('[data-rstrip]', root).forEach(st => {
        if (!once(st, 'ppStrip') || !REV.items.length) return;
        const idx = (st.dataset.reviews || '').split(',').map(s => parseInt(s, 10) - 1).filter(i => REV.items[i]);
        if (!idx.length) return;
        const tr = $('[data-rstrip-track]', st); const esc = s => String(s || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        tr.innerHTML = idx.map(i => { const r = REV.items[i]; return `<div class="rmini"><button type="button" data-ri="${i}"><img src="${esc(r.th || r.img)}" width="76" height="76" alt="" loading="lazy" decoding="async"><span><span class="stars" aria-hidden="true">★★★★★</span><q>${esc(r.q)}</q><small>${esc(r.n)}</small></span></button></div>` }).join('');
        $$('button', tr).forEach(b => b.addEventListener('click', () => LB.open(+b.dataset.ri, idx)));
        st.hidden = false; PP.carousel(tr);
      });
    }

    /* ===== hero card deck: swipe, tap, autoplay ===== */
    function initDeck(root) {
      $$('[data-deck]', root).forEach(deck => {
        if (!once(deck, 'ppDeck')) return;
        let order = $$('.card', deck), busy = false, auto, touched = false;
        if (order.length < 2) return;
        function layout() {
          order.forEach((c, i) => {
            c.style.zIndex = order.length - i;
            const r = i === 0 ? -2 : (i % 2 ? 5 : -6) + i;
            c.style.transform = `translate(${i * 6}px, ${i * 12}px) rotate(${r}deg) scale(${1 - i * .045})`;
            c.style.opacity = i > 3 ? 0 : 1;
            c.setAttribute('aria-hidden', i ? 'true' : 'false');
            const im = $('img', c); if (im && i < 3 && im.loading === 'lazy') im.loading = 'eager';
          });
        }
        function next(dir = 1) {
          if (busy) return; busy = true; buzz();
          const top = order[0];
          top.style.transform = `translate(${dir * 120}%, -6%) rotate(${dir * 24}deg)`; top.style.opacity = 0;
          setTimeout(() => { order.push(order.shift()); layout(); busy = false }, RM ? 0 : 340);
        }
        layout();
        let x0, y0, dx = 0, dragging = false, cur;
        deck.addEventListener('pointerdown', e => {
          cur = order[0]; if (!cur.contains(e.target) && e.target !== cur) return;
          x0 = e.clientX; y0 = e.clientY; dx = 0; dragging = true; touched = true; stop();
          cur.classList.add('dragging'); deck.setPointerCapture(e.pointerId);
        });
        deck.addEventListener('pointermove', e => { if (!dragging) return; dx = e.clientX - x0; const dy = (e.clientY - y0) * .25; cur.style.transform = `translate(${dx}px, ${dy}px) rotate(${dx / 14 - 2}deg)` });
        deck.addEventListener('pointerup', () => { if (!dragging) return; dragging = false; cur.classList.remove('dragging'); if (Math.abs(dx) > 70) next(Math.sign(dx)); else if (Math.abs(dx) < 6) next(1); else layout() });
        deck.addEventListener('pointercancel', () => { if (!dragging) return; dragging = false; cur.classList.remove('dragging'); layout() });
        const nb = $('[data-deck-next]', deck.parentNode); nb && nb.addEventListener('click', () => { touched = true; stop(); next(1) });
        function startA() { if (RM || touched || (window.Shopify && Shopify.designMode)) return; stop(); auto = setInterval(() => next(1), 4000) }
        function stop() { clearInterval(auto) }
        new IntersectionObserver(es => es[0].isIntersecting ? startA() : stop()).observe(deck);
        deck.addEventListener('mouseenter', stop); deck.addEventListener('mouseleave', startA);
      });
    }

    /* ===== bond: words light up as you read ===== */
    function initBond(root) {
      $$('[data-bond-text]', root).forEach(h => {
        if (!once(h, 'ppBond')) return;
        const wrapWords = node => [...node.childNodes].forEach(n => {
          if (n.nodeType === 3) { const f = document.createDocumentFragment(); n.textContent.split(/(\s+)/).forEach(t => { if (!t) return; if (/^\s+$/.test(t)) f.appendChild(document.createTextNode(t)); else { const s = document.createElement('span'); s.className = 'w'; s.textContent = t; f.appendChild(s) } }); n.replaceWith(f) }
          else if (n.nodeType === 1) wrapWords(n);
        });
        wrapWords(h);
        const ws = $$('.w', h); if (RM || (window.Shopify && Shopify.designMode)) { ws.forEach(w => w.classList.add('on')); return }
        let tk = false;
        const upd = () => { tk = false; const r = h.getBoundingClientRect(), vh = innerHeight; const p = Math.min(1, Math.max(0, (vh * .86 - r.top) / (r.height + vh * .38))); const n = Math.round(p * ws.length * 1.05); ws.forEach((w, i) => w.classList.toggle('on', i < n)) };
        addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(upd) } }, { passive: true }); upd();
      });
    }

    /* ===== style cards: flip + filter ===== */
    function initStyles(root) {
      $$('[data-section-type="styles"]', root).forEach(sec => {
        if (!once(sec, 'ppStyles')) return;
        const track = $('[data-track]', sec);
        PP.carousel(track, $('[data-prog]', sec), $('[data-arrows]', sec));
        $$('.sc:not(.gift)', sec).forEach(sc => {
          const front = $('.front', sc), back = $('.back', sc);
          const flip = on => { sc.classList.toggle('flipped', on); back.inert = !on; front.inert = on; buzz(); setTimeout(() => (on ? $('.btn', back) : $('.tap', front)).focus({ preventScroll: true }), RM ? 0 : 380) };
          $('[data-flip]', sc).addEventListener('click', () => flip(true));
          $('[data-unflip]', sc).addEventListener('click', () => flip(false));
        });
        PP.chipGroup($('[data-chips="styles"]', sec), f => {
          const cards = $$('.sc', track);
          cards.forEach(c => c.classList.add('out'));
          setTimeout(() => {
            cards.forEach(c => { const tags = (c.dataset.tags || '').split(/\s+/); const show = f === 'all' || tags.includes(f) || c.dataset.tags === 'all'; c.hidden = !show; c.classList.remove('flipped'); const b = $('.back', c), fr = $('.front', c); if (b) { b.inert = true; fr.inert = false } });
            track.scrollLeft = 0;
            let k = 0; cards.forEach(c => { if (!c.hidden) { const d = k++; setTimeout(() => c.classList.remove('out'), RM ? 0 : 30 + d * 50) } });
            track._upd && track._upd();
          }, RM ? 0 : 240);
        });
      });
    }

    /* ===== simple carousels (how it works, gift perks) ===== */
    function initTracks(root) {
      $$('[data-section-type="how"], [data-section-type="gift"]', root).forEach(sec => {
        const t = $('[data-track]', sec); PP.carousel(t, $('[data-prog]', sec));
      });
    }

    /* ===== odometer ===== */
    function initOdo(root) {
      $$('[data-odo]', root).forEach(el => {
        if (!once(el, 'ppOdo')) return;
        const val = el.dataset.value || ''; const cols = [];
        [...val].forEach(ch => {
          if (/\d/.test(ch)) {
            const d = document.createElement('span'); d.className = 'd';
            const col = document.createElement('span'); col.className = 'col';
            for (let k = 0; k < 20; k++) { const s = document.createElement('span'); s.textContent = k % 10; col.appendChild(s) }
            d.appendChild(col); el.appendChild(d); cols.push([col, +ch]);
          } else { const s = document.createElement('span'); s.textContent = ch; el.appendChild(s) }
        });
        const fin = ([c, n]) => `translateY(-${(n + 10) * 5}%)`;
        if (RM) { cols.forEach(x => { x[0].style.transition = 'none'; x[0].style.transform = fin(x) }); return }
        PP.onView(el, () => cols.forEach((x, i) => { x[0].style.transitionDelay = (i * .12) + 's'; x[0].style.transform = fin(x) }), { threshold: .5 });
      });
    }

    /* ===== before / after ===== */
    function initBA(root) {
      $$('[data-ba]', root).forEach(ba => {
        if (!once(ba, 'ppBa')) return;
        const r = $('[data-ba-range]', ba), h = $('.handle', ba);
        const set = p => { ba.style.setProperty('--p', p + '%'); h.style.setProperty('--px', (ba.clientWidth * p / 100) + 'px') };
        r.addEventListener('input', () => set(r.value));
        r.addEventListener('pointerdown', () => ba.classList.add('active'));
        addEventListener('pointerup', () => ba.classList.remove('active'));
        new ResizeObserver(() => set(r.value)).observe(ba);
        set(50);
        if (RM) return;
        PP.onView(ba, () => {
          const t0 = performance.now();
          const wig = t => { const k = (t - t0) / 1700; if (k > 1 || ba.classList.contains('active')) return set(r.value); const p = 50 + Math.sin(k * Math.PI * 2) * 20 * (1 - k); r.value = p; set(p); requestAnimationFrame(wig) };
          setTimeout(() => requestAnimationFrame(wig), 350);
        }, { threshold: .6 });
      });
    }

    /* ===== gift card ===== */
    function initGift(root) {
      $$('[data-gc]', root).forEach(z => {
        if (!once(z, 'ppGc')) return;
        const gc = $('[data-gc-card]', z), amt = $('[data-gc-amt]', z), buy = $('[data-gc-buy]', z);
        gc.addEventListener('click', () => { const on = !gc.classList.contains('flipped'); gc.classList.toggle('flipped', on); gc.setAttribute('aria-pressed', on); buzz() });
        $$('.amt-b', z).forEach(b => b.addEventListener('click', () => {
          $$('.amt-b', z).forEach(x => x.setAttribute('aria-pressed', x === b));
          gc.classList.remove('flipped'); gc.setAttribute('aria-pressed', 'false');
          amt.textContent = b.dataset.amount; amt.classList.remove('pop'); void amt.offsetWidth; amt.classList.add('pop');
          if (buy) { buy.textContent = (buy.dataset.label || '').replace('[amount]', b.dataset.amount); buy.href = b.dataset.url }
          buzz();
        }));
      });
    }

    /* ===== comparison: one alternative at a time on mobile ===== */
    function initCompare(root) {
      $$('[data-section-type="compare"]', root).forEach(sec => {
        if (!once(sec, 'ppCmp')) return;
        const w = $('[data-cmp]', sec);
        PP.chipGroup($('[data-chips="compare"]', sec), f => { w.classList.add('fade'); setTimeout(() => { w.dataset.vs = f; requestAnimationFrame(() => w.classList.remove('fade')) }, RM ? 0 : 220) });
      });
    }

    /* ===== final CTA: live name ===== */
    function initFinal(root) {
      $$('[data-final]', root).forEach(box => {
        if (!once(box, 'ppFinal')) return;
        const sec = box.closest('section'); const inp = $('[data-final-input]', box), nm = $('[data-final-name]', sec), btn = $('[data-final-btn]', box); let t;
        inp.addEventListener('input', () => {
          const v = inp.value.trim();
          clearTimeout(t);
          t = setTimeout(() => { nm.classList.add('write'); nm.textContent = v || nm.dataset.default; void nm.offsetWidth; nm.classList.remove('write') }, 140);
          btn.textContent = v ? (btn.dataset.labelName || '').replace('[name]', v) : btn.dataset.label;
          try { sessionStorage.setItem('pp_name', v) } catch (e) {}
        });
      });
    }


    /* ===== before/after cases: chips, prev/next, swipe on the text, one slider per case ===== */
    function initCases(root) {
      if (!root || root._init) return; root._init = true;
      const panes = $$('.cs-pane', root), keys = panes.map(p => p.dataset.ck); let cur = 0;
      panes.forEach(p => {
        const ba = $('.cba', p), r = $('input', ba), h = $('.handle', ba);
        const set = v => { ba.style.setProperty('--p', v + '%'); h.style.setProperty('--px', (ba.clientWidth * v / 100) + 'px') };
        r.addEventListener('input', () => set(r.value)); new ResizeObserver(() => set(r.value)).observe(ba); set(50);
        p._wiggle = () => { if (RM) return; const t0 = performance.now(); const w = t => { const k = (t - t0) / 1500; if (k > 1) return set(r.value); const v = 50 + Math.sin(k * Math.PI * 2) * 16 * (1 - k); r.value = v; set(v); requestAnimationFrame(w) }; requestAnimationFrame(w) };
      });
      const chips = $('.cs-chips', root);
      function go(i, from) {
        i = (i + panes.length) % panes.length; if (i === cur) return; const dir = i > cur ? 1 : -1; cur = i;
        panes.forEach((p, k) => { p.hidden = k !== i; p.style.setProperty('--dir', dir) });
        if (from !== 'chip') { $$('.chip', chips).forEach(c => c.setAttribute('aria-pressed', c.dataset.f === keys[i])); window.dispatchEvent(new Event('resize')); const c = $$('.chip', chips)[i]; chips.scrollTo({ left: c.offsetLeft - (chips.clientWidth - c.offsetWidth) / 2, behavior: RM ? 'auto' : 'smooth' }) }
        setTimeout(() => panes[i]._wiggle(), 250); buzz();
      }
      PP.chipGroup(chips, k => go(keys.indexOf(k), 'chip'));
      $$('.cs-nav button', root).forEach(b => b.addEventListener('click', () => go(cur + +b.dataset.d)));
      let sx = null, sy = 0;
      $$('.cs-txt', root).forEach(t => { t.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY }); t.addEventListener('pointerup', e => { if (sx === null) return; const dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1)) }) });
      PP.onView(root, () => setTimeout(() => panes[0] && panes[0]._wiggle(), 300), { threshold: .5 });
    }
    PP.initCases = initCases;

    /* ===== glowing frame: lights on/off (crossfade day/evening photo) ===== */
    /* plain crossfade between the day and evening photo (no flicker) */
    function lightsOn(gp, on) { gp.classList.toggle('lit', on) }
    function initGlow(root) {
      $$('[data-glow-switch]', root).forEach(sw => {
        if (!once(sw, 'ppGlow')) return;
        const box = sw.closest('[data-glow-box]') || sw.parentNode, gp = $('.gp', box), scope = sw.closest('[data-glow-scope]');
        const dn = scope && $('[data-daynight]', scope);
        const set = (on, quiet) => {
          lightsOn(gp, on); sw.setAttribute('aria-pressed', on); const l = $('[data-l]', sw); if (l) l.textContent = on ? sw.dataset.off : sw.dataset.on;
          if (scope) scope.classList.toggle('night', on);
          dn && $$('button', dn).forEach(b => b.setAttribute('aria-pressed', (b.dataset.v === 'night') === on));
          if (!quiet) buzz();
        };
        sw.addEventListener('click', () => set(!gp.classList.contains('lit')));
        dn && $$('button', dn).forEach(b => b.addEventListener('click', () => set(b.dataset.v === 'night')));
        if (sw.hasAttribute('data-auto')) { if (RM) set(true, true); else PP.onView(gp, () => setTimeout(() => set(true, true), 900), { threshold: .5 }) }
      });
    }

    /* ===== format tiles: hide the current format on the product page ===== */
    function initFmtTiles(root) {
      $$('[data-fmt-tiles]', root).forEach(sec => {
        if (!once(sec, 'ppFmt')) return;
        const t = $('[data-track]', sec); PP.carousel(t, $('[data-prog]', sec), $('[data-arrows]', sec));
        if (sec.hasAttribute('data-other')) document.addEventListener('pp:format', e => { $$('[data-fkey]', sec).forEach(a => { a.hidden = a.dataset.fkey === e.detail.key }); t._upd && t._upd() });
      });
    }

    /* ===== collection: format chips update links and prices ===== */
    function initFmtChips(root) {
      $$('[data-fmt-chips]', root).forEach(ch => {
        if (!once(ch, 'ppFch')) return;
        const scope = ch.closest('[data-section-type="collection"]') || document;
        const info = $('[data-fmt-info]', scope);
        const apply = (f, anim) => {
          const c = $(`.chip[data-f="${f}"]`, ch);
          $$('[data-fprices]', scope).forEach(card => {
            let pr = {}; try { pr = JSON.parse(card.dataset.fprices) } catch (e) {}
            const cents = pr[f], from = $('[data-from-price]', card), link = card.dataset.url;
            $$('a[data-plink]', card).forEach(a => { a.href = f === 'all' || !cents ? link : link + (link.indexOf('?') > -1 ? '&' : '?') + 'fmt=' + f });
            if (from && cents) { from.textContent = PP.money(cents); if (anim && !RM) { from.classList.remove('bump'); void from.offsetWidth; from.classList.add('bump') } }
            const was = $('[data-from-was]', card), dp = +(document.documentElement.dataset.dealPct || 0); if (was && cents && dp > 0) { was.hidden = false; was.textContent = PP.money(Math.round(cents * 100 / (100 - dp))) }
            const fn = $('[data-fn]', card); if (fn) fn.textContent = c ? c.dataset.as || '' : '';
          });
          if (info && c) { $('[data-fi-name]', info).textContent = c.textContent; $('[data-fi-from]', info).textContent = c.dataset.from || ''; const m = $('[data-fi-more]', info); if (m) { m.href = c.dataset.page || m.href; m.hidden = !c.dataset.page } const th = $('[data-fi-thumb]', info); if (th) th.innerHTML = c.dataset.thumb ? `<span class="gp"><img src="${c.dataset.thumb}" alt="" width="64" height="64"></span>` : '' }
          /* ?fmt=, never ?format=: Shopify reads ?format= as a response format and answers 404 on reload */
          if (history.replaceState && !(window.Shopify && Shopify.designMode)) { const u = new URL(location.href); u.searchParams.delete('format'); u.searchParams.set('fmt', f); history.replaceState(null, '', u) }
        };
        PP.chipGroup(ch, f => apply(f, true));
        const q = new URLSearchParams(location.search).get('fmt');
        const start = (q && $(`.chip[data-f="${q}"]`, ch)) ? q : ($('.chip[aria-pressed="true"]', ch) || {}).dataset && $('.chip[aria-pressed="true"]', ch).dataset.f;
        if (start) { const c = $(`.chip[data-f="${start}"]`, ch); ch._pick && ch._pick(c, true); apply(start, false) }
      });
    }

    /* ===== header: Styles / Products / Occasions tabs in the menu sheet ===== */
    function initMenuTabs() {
      const sheet = document.getElementById('menuSheet'); if (!sheet || sheet._tabs) return; sheet._tabs = true;
      const tabs = $('[data-menu-tabs]', sheet); if (!tabs) return;
      const panes = $$('[data-mpane]', sheet), pick = t => panes.forEach(p => p.hidden = p.dataset.mpane !== t);
      PP.chipGroup(tabs, pick);
      const sh = PP.makeSheet(sheet);
      $$('[data-menu]').forEach(b => b.addEventListener('click', () => { const t = b.dataset.menu; const c = $(`.chip[data-f="${t}"]`, tabs); if (c && tabs._pick) tabs._pick(c, true); pick(t); sh.open(); requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))) }));
    }

    PP.register(root => { $$('[data-cases]', root).forEach(c => { if (!c.closest('[data-sheet]')) initCases(c) }); initGlow(root); initFmtTiles(root); initFmtChips(root); initMenuTabs(); $$('[data-io]', root) });

    PP.register(root => { initReviews(root); initDeck(root); initBond(root); initStyles(root); initTracks(root); initOdo(root); initBA(root); initGift(root); initCompare(root); initFinal(root) });
  };
  start();
})();
